import React, { useEffect, useState } from 'react'
import { Select, Form, message } from 'antd'
import Hexapi from '../utility/HexAPI/Hexapi'
import { Aesencryption } from '../utility/Aes/Aes'

const { Option } = Select

/* ─── Scoped styles ─────────────────────────────────────────── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .gl-overlay {
    position: fixed;
    inset: 0;
    background: rgba(8, 15, 40, 0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    animation: gl-fadeIn 0.2s ease;
  }

  @keyframes gl-fadeIn {
    from { opacity: 0 }
    to   { opacity: 1 }
  }

  @keyframes gl-slideUp {
    from { opacity: 0; transform: translateY(24px) scale(0.97) }
    to   { opacity: 1; transform: translateY(0) scale(1) }
  }

  @keyframes gl-linkReveal {
    from { opacity: 0; transform: translateY(10px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  .gl-modal {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #ffffff;
    border-radius: 20px;
    width: 480px;
    max-width: calc(100vw - 32px);
    box-shadow:
      0 0 0 1px rgba(18, 80, 172, 0.08),
      0 8px 24px rgba(18, 80, 172, 0.10),
      0 32px 64px rgba(8, 15, 40, 0.14);
    animation: gl-slideUp 0.28s cubic-bezier(0.34, 1.36, 0.64, 1);
    overflow: hidden;
  }

  /* ── Header ── */
  .gl-header {
    background: linear-gradient(135deg, #0f3d8c 0%, #1250ac 50%, #1a6fd4 100%);
    padding: 28px 28px 24px;
    position: relative;
    overflow: hidden;
  }
  .gl-header::before {
    content: '';
    position: absolute;
    top: -40px; right: -40px;
    width: 180px; height: 180px;
    border-radius: 50%;
    background: rgba(255,255,255,0.06);
  }
  .gl-header::after {
    content: '';
    position: absolute;
    bottom: -60px; left: 30px;
    width: 140px; height: 140px;
    border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }
  .gl-header-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }
  .gl-icon-wrap {
    width: 48px; height: 48px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 14px;
    display: flex; align-items: center; justify-content: center;
  }
  .gl-icon-wrap svg {
    width: 22px; height: 22px;
    fill: none;
    stroke: #fff;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .gl-close-btn {
    width: 32px; height: 32px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.2);
    background: rgba(255,255,255,0.1);
    color: #fff;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.18s;
  }
  .gl-close-btn:hover { background: rgba(255,255,255,0.22); }
  .gl-header-title {
    margin-top: 16px;
    position: relative; z-index: 1;
  }
  .gl-header-title h2 {
    margin: 0 0 4px;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.3px;
  }
  .gl-header-title p {
    margin: 0;
    font-size: 13px;
    color: rgba(255,255,255,0.65);
    font-weight: 400;
  }

  /* ── Body ── */
  .gl-body {
    padding: 28px 28px 24px;
  }

  /* ── Field ── */
  .gl-field { margin-bottom: 20px; }
  .gl-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 7px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }
  .gl-label span { color: #ef4444; margin-left: 2px; }

  .gl-field .ant-select { width: 100% !important; }
  .gl-field .ant-select-selector {
    height: 44px !important;
    border-radius: 10px !important;
    border: 1.5px solid #e5e7eb !important;
    background: #f9fafb !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 14px !important;
    transition: border-color 0.18s, box-shadow 0.18s !important;
    padding: 0 14px !important;
  }
  .gl-field .ant-select-selector:hover { border-color: #1250ac !important; }
  .gl-field .ant-select-focused .ant-select-selector {
    border-color: #1250ac !important;
    box-shadow: 0 0 0 3px rgba(18,80,172,0.10) !important;
    background: #fff !important;
  }
  .gl-field .ant-select-selection-placeholder {
    line-height: 42px !important;
    color: #9ca3af !important;
  }
  .gl-field .ant-select-selection-item {
    line-height: 42px !important;
    font-weight: 500 !important;
    color: #111827 !important;
  }
  .gl-field .ant-select-arrow { color: #9ca3af !important; }

  .gl-error {
    font-size: 12px;
    color: #ef4444;
    margin-top: 5px;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  /* ── Generate button ── */
  .gl-generate-btn {
    width: 100%;
    height: 48px;
    border-radius: 12px;
    border: none;
    background: linear-gradient(135deg, #0f3d8c, #1250ac, #1a6fd4);
    background-size: 200% auto;
    color: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 14.5px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 4px;
    transition: background-position 0.4s ease, box-shadow 0.2s, transform 0.15s;
    box-shadow: 0 4px 14px rgba(18,80,172,0.30);
    letter-spacing: 0.1px;
  }
  .gl-generate-btn:hover:not(:disabled) {
    background-position: right center;
    box-shadow: 0 6px 20px rgba(18,80,172,0.40);
    transform: translateY(-1px);
  }
  .gl-generate-btn:active:not(:disabled) { transform: translateY(0); }
  .gl-generate-btn:disabled { opacity: 0.55; cursor: not-allowed; box-shadow: none; }
  .gl-generate-btn svg {
    width: 17px; height: 17px;
    stroke: #fff; fill: none;
    stroke-width: 2; stroke-linecap: round; stroke-linejoin: round;
  }

  /* ── Generated link box ── */
  .gl-link-box {
    animation: gl-linkReveal 0.3s cubic-bezier(0.34,1.36,0.64,1);
    background: linear-gradient(135deg, #eff6ff 0%, #f0f9ff 100%);
    border: 1.5px solid #bfdbfe;
    border-radius: 12px;
    padding: 14px 16px;
    margin-top: 20px;
  }
  .gl-link-label {
    font-size: 11px;
    font-weight: 700;
    color: #1250ac;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .gl-link-label::before {
    content: '';
    display: inline-block;
    width: 6px; height: 6px;
    border-radius: 50%;
    background: #22c55e;
    box-shadow: 0 0 0 3px rgba(34,197,94,0.20);
  }
  .gl-link-inner {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }
  .gl-link-text {
    flex: 1;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11.5px;
    color: #1e40af;
    word-break: break-all;
    line-height: 1.6;
    font-weight: 500;
  }
  .gl-copy-btn {
    flex-shrink: 0;
    width: 34px; height: 34px;
    border-radius: 8px;
    border: 1.5px solid #bfdbfe;
    background: #fff;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
    margin-top: 1px;
  }
  .gl-copy-btn:hover { background: #1250ac; border-color: #1250ac; }
  .gl-copy-btn:hover svg { stroke: #fff; }
  .gl-copy-btn.copied { background: #22c55e; border-color: #22c55e; }
  .gl-copy-btn.copied svg { stroke: #fff; }
  .gl-copy-btn svg {
    width: 14px; height: 14px;
    stroke: #1250ac; fill: none;
    stroke-width: 2.2; stroke-linecap: round; stroke-linejoin: round;
    transition: stroke 0.18s;
  }

  /* ── Divider ── */
  .gl-divider { height: 1px; background: #f3f4f6; }

  /* ── Footer ── */
  .gl-footer {
    padding: 16px 28px;
    display: flex;
    justify-content: flex-end;
  }
  .gl-btn-secondary {
    height: 38px;
    padding: 0 18px;
    border-radius: 9px;
    border: 1.5px solid #e5e7eb;
    background: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13.5px;
    font-weight: 600;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.18s;
  }
  .gl-btn-secondary:hover { border-color: #d1d5db; color: #374151; background: #f9fafb; }

  /* ── Spinner ── */
  .gl-spin {
    display: inline-block;
    width: 14px; height: 14px;
    border: 2px solid rgba(255,255,255,0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: gl-rotate 0.7s linear infinite;
  }
  @keyframes gl-rotate { to { transform: rotate(360deg) } }
`

/* ─── Icons ──────────────────────────────────────────────────── */
const IconLink = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/>
  </svg>
)
const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="17" height="17">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
)
const IconCopy = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
  </svg>
)
const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
)
const IconClose = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" width="14" height="14">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
)
const IconSource = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" width="13" height="13">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
  </svg>
)
const IconPosition = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" width="13" height="13">
    <rect x="2" y="7" width="20" height="14" rx="2"/>
    <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
  </svg>
)

/* ─── Main Component ─────────────────────────────────────────── */
const Generatelinks = ({ agentid, open, onClose }) => {
  const [form] = Form.useForm()
  const [sourceList, setSourceList]       = useState([])
  const [positionList, setPositionList]   = useState([])
  const [loading, setLoading]             = useState(false)
  const [generating, setGenerating]       = useState(false)
  const [generatedLink, setGeneratedLink] = useState('')
  const [copied, setCopied]               = useState(false)
  const [errors, setErrors]               = useState({})
  const [apiUrl, setApiUrl]               = useState('')

  const getApiUrl = async () => {
    try {
      const resp = await fetch('/apiinfo.json')
      const data = await resp.json()
      setApiUrl(data.apipathurl || window.location.origin)
    } catch {
      setApiUrl(window.location.origin)
    }
  }

  const getdata = async () => {
    try {
      setLoading(true)
      const obj = {
        query: `[dbo].[HCMS_Proc_generatelink_getformdata] @agentid='{0}'`,
        queryArr: [`${agentid}`],
      }
      const resp = await Hexapi(obj)
      setSourceList(Array.isArray(resp?.source) ? resp.source : [])
      setPositionList(Array.isArray(resp?.appliedpostionfor) ? resp.appliedpostionfor : [])
    } catch (error) {
      message.error('Failed to load form data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!agentid || !open) return
    getApiUrl()
    getdata()
    form.resetFields()
    setGeneratedLink('')
    setCopied(false)
    setErrors({})
  }, [agentid, open])

  const handleGenerate = async () => {
    const values = form.getFieldsValue()
    const newErrors = {}
    if (!values.sourceid)        newErrors.sourceid = 'Please select a source'
    if (!values.appliedposition) newErrors.appliedposition = 'Please select a position'
    if (Object.keys(newErrors).length) { setErrors(newErrors); return }
    setErrors({})
    setGenerating(true)
    await new Promise(r => setTimeout(r, 400))
    const encrypted = Aesencryption(
      `agentID=${agentid}&sourceid=${values.sourceid}&appliedposition=${values.appliedposition}`
    )
    setGeneratedLink(`${apiUrl}candidate-form?${encrypted}`)
    setGenerating(false)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedLink).then(() => {
      setCopied(true)
      message.success('Link copied!')
      setTimeout(() => setCopied(false), 2500)
    })
  }

  const handleClose = () => {
    onClose()
    form.resetFields()
    setGeneratedLink('')
    setErrors({})
  }

  if (!open) return null

  return (
    <>
      <style>{styles}</style>
      <div className="gl-overlay" onClick={(e) => e.target === e.currentTarget && handleClose()}>
        <div className="gl-modal">

          {/* ── Header ── */}
          <div className="gl-header">
            <div className="gl-header-top">
              <div className="gl-icon-wrap"><IconLink /></div>
              <button className="gl-close-btn" onClick={handleClose}><IconClose /></button>
            </div>
            <div className="gl-header-title">
              <h2>Generate Candidate Link</h2>
              <p>Create a shareable link for candidate registration</p>
            </div>
          </div>

          {/* ── Body ── */}
          <div className="gl-body">
            <Form form={form} layout="vertical">

              {/* Source */}
              <div className="gl-field">
                <label className="gl-label">
                  <IconSource /> Source <span>*</span>
                </label>
                <Form.Item name="sourceid" noStyle>
                  <Select
                    placeholder="Select recruitment source"
                    loading={loading}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    onChange={() => setErrors(e => ({ ...e, sourceid: null }))}
                    style={{ width: '100%' }}
                  >
                    {sourceList.map(item => (
                      <Option key={item.recid} value={item.recid}>
                        {item.sourcename}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {errors.sourceid && (
                  <div className="gl-error">⚠ {errors.sourceid}</div>
                )}
              </div>

              {/* Applied Position */}
              <div className="gl-field">
                <label className="gl-label">
                  <IconPosition /> Applied Position <span>*</span>
                </label>
                <Form.Item name="appliedposition" noStyle>
                  <Select
                    placeholder="Select applied position"
                    loading={loading}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    onChange={() => setErrors(e => ({ ...e, appliedposition: null }))}
                    style={{ width: '100%' }}
                  >
                    {positionList.map(item => (
                      <Option key={item.recid} value={item.recid}>
                        {item.appliedpostionname?.trim()}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                {errors.appliedposition && (
                  <div className="gl-error">⚠ {errors.appliedposition}</div>
                )}
              </div>

              {/* Generate Button */}
              <button
                className="gl-generate-btn"
                onClick={handleGenerate}
                disabled={generating || loading}
              >
                {generating
                  ? <><span className="gl-spin" /> Generating…</>
                  : <><IconArrow /> Generate Link</>
                }
              </button>

              {/* Generated Link */}
              {generatedLink && (
                <div className="gl-link-box">
                  <div className="gl-link-label">Link Ready</div>
                  <div className="gl-link-inner">
                    <span className="gl-link-text">{generatedLink}</span>
                    <button
                      className={`gl-copy-btn${copied ? ' copied' : ''}`}
                      onClick={handleCopy}
                      title={copied ? 'Copied!' : 'Copy link'}
                    >
                      {copied ? <IconCheck /> : <IconCopy />}
                    </button>
                  </div>
                </div>
              )}

            </Form>
          </div>

          {/* ── Footer ── */}
          <div className="gl-divider" />
          {/* <div className="gl-footer">
            <button className="gl-btn-secondary" onClick={handleClose}>Cancel</button>
          </div> */}

        </div>
      </div>
    </>
  )
}

export default Generatelinks
